
import React, { useEffect, useState } from 'react';
import { Document, Page, PDFViewer, View, Font, pdf } from '@react-pdf/renderer';

import { pageStyle } from './termReportPDFStyle';
import { HeaderLogoSection, HeaderAddressSection, HeaderNameSection } from "./termReportHeader.js";
import TermReportStudentSection from './termReportStudent';
import TermReportScore from './termReportScore';
import FooterSection from './termReportFooter';


const TermReportPdfAndroid = (props) => {
    const [headerName, setHeaderName] = useState("");
    const [reportHeader, setReportHeader] = useState({});
    const [clsSectionDtls, setClsSectionDtls] = useState({});
    const [lstStudent, setLstStudent] = useState([]);
    const [principalSign, setPrincipalSign] = useState('');
    const [teacherSign, setTeacherSign] = useState('');
    const [lstTermExamHdr, setLstTermExamHdr] = useState([]);
    const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);

    useEffect(() => {
        // console.log("TermReportPDF called");
        // console.log("props.termReportCard", props.termReportCard);
        // console.log("props.termReportCard.headerName", props.termReportCard.headerName);
        // console.log("props.termReportCard.reportHeader", props.termReportCard.reportHeader);
        // console.log("props.termReportCard.clsSectionDtls", props.termReportCard.clsSectionDtls);
        // console.log("props.termReportCard.lstStudent", props.termReportCard.lstStudent);
        props.setLoader("block");
        if (props.termReportCard) {
            setHeaderName(props.termReportCard.headerName ? props.termReportCard.headerName : null);
            setReportHeader(props.termReportCard.reportHeader ? props.termReportCard.reportHeader : null);
            setClsSectionDtls(props.termReportCard.clsSectionDtls ? props.termReportCard.clsSectionDtls : null);
            setLstStudent(props.termReportCard.lstStudent ? props.termReportCard.lstStudent : null);
            setTeacherSign(props.termReportCard.clsSectionDtls && props.termReportCard.clsSectionDtls.signClassTeacher ? props.termReportCard.clsSectionDtls.signClassTeacher : null);
        }
        setLstTermExamHdr(props.termReportCard.lstTermExamHdr);
        setPrincipalSign(props.principalSign ? props.principalSign : "");
    }, [props.termReportCard, props.logoUrl, props.principalSign]);

    const pages = [];

    

    const generateDocument = () => new Promise((resolve) => {
        const generatedDocument = (
            <Document>{pages}</Document>
        );
        resolve(generatedDocument);
    });

    
    const openDocument = async () => {
        // console.log("openDocument called");
        await setDocumentLoadingCalled(true);
        const document = await generateDocument();

        try {
            // Step 1: Generate the PDF Blob
            const blob = await pdf(document).toBlob();

            // Step 2: Check the file size (in bytes)
            const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB

            // Define a threshold for the file size (for example, 10MB)
            const fileSizeThreshold = 10;

            if (fileSizeInMB > fileSizeThreshold) {
                // If file is too large, suggest downloading
                window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

                // Force download if file is too large
                const downloadLink = document.createElement('a');
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = 'AnswerSheet.pdf';
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            } else {
                // Step 3: Attempt to open the PDF in a new tab
                const fileURL = URL.createObjectURL(blob);
                const newTab = window.open(fileURL, '_blank');

                // Step 4: Check if the tab was successfully opened
                if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                    window.alert('Popup blocked. Downloading file instead...');
                    const downloadLink = document.createElement('a');
                    downloadLink.href = fileURL;
                    downloadLink.download = 'AnswerSheet.pdf'; // Set default filename
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            }
        } catch (error) {
            console.error('Error opening or downloading PDF:', error);
        }
        finally {
            props.setLoader("none");
            props.closePdf();
        }
    };


    if (!!lstStudent) {
        // console.log("inside condition !!lstStudent, lstStudent.length", lstStudent.length);
        for (let i = 0; i < lstStudent.length; i++) {
            if (i === lstStudent.length-1 && !documentOpeningCalled) {
                // console.log("inside condtion i  is at last student length");
                openDocument();
            }
            pages.push(
                <Page
                    key={lstStudent[i].studentHeader.studentId}
                    size="A4" style={pageStyle.page}>
                    <View style={pageStyle.page_border}>

                        <View style={pageStyle.header_section}>
                            <View style={pageStyle.header_logo}>
                                <HeaderLogoSection
                                    logoUrl={props.logoUrl}
                                    reportHeader={reportHeader}
                                />
                            </View>
                            <View style={pageStyle.header_address}>
                                <HeaderAddressSection
                                    reportHeader={reportHeader}
                                />
                            </View>
                            <View style={pageStyle.header_name}>
                                <HeaderNameSection
                                    // headerName={headerName}
                                    headerName={"Performance Profile " + props.term}
                                />
                            </View>
                        </View>
                        <View style={pageStyle.student_section}>
                            <TermReportStudentSection
                                studentHeader={lstStudent[i].studentHeader}
                                clsSectionDtls={clsSectionDtls}
                            />
                        </View>
                        <View style={pageStyle.score_section}>
                            <TermReportScore
                                studentSummary={lstStudent[i].studentSummary}
                                lstScholastic={lstStudent[i].lstScholastic}
                                lstCoscholastic={lstStudent[i].lstCoscholastic}
                                lstExam={lstTermExamHdr}
                                term={props.term}
                            />
                        </View>
                        <View style={pageStyle.footer_section}>
                            <FooterSection
                                principalSign={principalSign}
                                teacherSign={teacherSign}
                            />
                        </View>
                    </View>
                </Page>
            );
        }
    }


    return (
        <div >
        </div>
    );

}

export default TermReportPdfAndroid;